import { IconButton } from '../../../lib/button'
import { FaEdit, FaToggleOn, FaToggleOff } from 'react-icons/fa'

export const Cols = (onRowClickUpdate, onToggleActive) => {
  return [
    {
      name: 'ID',
      selector: 'beslenmeType_id',
      sortable: true,
      width: '80px',
      cell: row => <div style={{ fontSize: 14, fontWeight: 'bold' }}>{row.beslenmeType_id}</div>
    },

    {
      name: 'Tip Adı',
      selector: 'beslenmeType_text',
      sortable: true,
      cell: row => (
        <div style={{ fontSize: 14 }}>
          {row.beslenmeType_text}
          {row.isStore == 1 && <span style={{ marginLeft: 8, fontSize: 11, color: '#999', fontStyle: 'italic' }}>(Store - Sabit)</span>}
        </div>
      )
    },

    {
      name: 'Durum',
      selector: 'isActive',
      sortable: true,
      width: '120px',
      cell: row => (
        <div style={{ fontSize: 13, fontWeight: 'bold', color: row.isActive == 1 ? '#4caf50' : '#f44336' }}>
          {row.isActive == 1 ? 'Aktif' : 'Pasif'}
        </div>
      )
    },

    {
      name: '',
      selector: 'toggle',
      sortable: false,
      width: '90px',
      cell: row => row.isStore == 1 ? null : (
        <IconButton
          icon={row.isActive == 1 ? <FaToggleOn size={30} color='#4caf50' /> : <FaToggleOff size={30} color='#f44336' />}
          onClick={() => onToggleActive(row.beslenmeType_id)}
        />
      )
    },

    {
      name: '',
      selector: 'update',
      sortable: false,
      width: '90px',
      cell: row => row.isStore == 1 ? null : (
        <IconButton
          icon={<FaEdit size={30} />}
          onClick={() => onRowClickUpdate(row.beslenmeType_id)}
        />
      )
    }
  ]
}
